<template>
  <div id="obstacle">
    <div v-for="(item, index) in questionList" :key="item.id" v-show="isShow">
      <div v-if="index == page">
        <oneTest v-if="item.showA === 1" :oneItem="item"></oneTest>
        <twoTest v-if="item.showA === 2" :twoItem="item"></twoTest>
        <threeTest v-if="item.showA === 3" :threeItem="item"></threeTest>
        <fourTest v-if="item.showA === 4" :fourItem="item"></fourTest>
        <div class="btnSwitch">
          <el-button
            type="warning"
            class="back"
            @click="toBack(item, index)"
            v-if="index != 0"
            :class="index == 0 ? 'before-back' : 'back'"
            >上一题</el-button
          >
          <el-button
            type="warning"
            class="next"
            @click="toNext(item, index)"
            v-if="isShowBtn"
            :class="index == 0 ? 'next' : 'before-next'"
            >下一题</el-button
          >

          <!-- 提交 -->
          <el-button
            type="danger"
            class="next"
            v-if="!isShowBtn"
            @click="submit(item, index)"
            :class="index == 0 ? 'next' : 'before-next'"
            >提交</el-button
          >
          <!--     -->
          <el-button
            type="warning"
            class="next"
            plain
            @click="showDialog = true"
            :class="index == 0 ? 'next' : 'before-next'"
            >指导手册</el-button
          >
        </div>

        <el-dialog :visible="showDialog" v-if="showDialog" @close="btnCancel">
          <div v-html="item.introduction" class="lightHe"></div>
        </el-dialog>
        <el-dialog
          :visible="showAfter"
          v-if="showAfter"
          @close="showAfterCancel"
          center
        >
          <div>
            由于分测验一和分测验二，是不及分数的。需要老师来描述一下学生表现的情况。
          </div>
          <div class="inputAfterDialog">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="inputAfter"
            ></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="showAfterOk">确 定</el-button>
            </span>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { scaleAnswerNextTimes } from '@/api/login/login.js';

import oneTest from './components/oneTest.vue';
import twoTest from './components/twoTest.vue';
import threeTest from './components/threeTest.vue';
import fourTest from './components/fourTest.vue';
//
export default {
  name: 'obstacle',
  data() {
    return {
      // loading: true,
      questionList: [
        {
          name: '分测验一：声音、语畅、语调',
          showA: 1,
          // nameAll: "评   量   结   果",
          // lastVoice: "一",
          // voiceAll: "", // 声音
          // languageAll: "", // 语畅
          // intonationAll: "", // 语调
          list: [
            {
              name: '1.“你叫什么名字？ 你今年几岁？你家里有些什么人？”',
              question: '1',
              pid: '1',
              voice: '', // 声音
              language: '', // 语畅
              intonation: '' // 语调
            },
            {
              name: '2.“请你自我介绍一下”',
              pid: '2',
              voice: '', // 声音
              language: '', // 语畅
              intonation: '' // 语调
            },
            {
              name: '3.“你说‘a----’，声音持续越久越好。”',
              pid: '3',
              voice: '', // 声音
              language: '', // 语畅
              intonation: '' // 语调
            },
            {
              name: '4.“你喜欢看什么电视节目？为什么？”',
              pid: '4',
              voice: '', // 声音
              language: '', // 语畅
              intonation: '' // 语调
            },
            {
              name: '5.“你说说早上醒来后到现在，做了哪一些事？”',
              pid: '5',
              voice: '', // 声音
              language: '', // 语畅
              intonation: '' // 语调
            },
            {
              name: '评   量   结   果',
              lastVoice: '一',
              pid: '评   量   结   果',
              voice: '', // 声音
              language: '', // 语畅
              intonation: '' // 语调
            }
          ],
          introduction:
            "<p>1、第1、2、4、5题：由施测者依题目念完后，要求受试回答。若受试回答内容只是在单字层次，可要求他/她多说一点，但每题的回答以不超过1分钟为原则。</p><p>2、第3题：<span style='color:red'>指导语：“你说‘a....’，越长越好。”</span>若儿童只说出短音[a]，施测者可用手势表示拉长的意思。</p><p>3、第1-5题不计分，主要与受测者建立关系，每题均只就声音及语畅的项目加以评量，而非内容、构音正确。</p>"
        },
        {
          name: '分测验二：语言理解',
          showA: 2,
          nameAll: '语言理解 共 40 分，评量结果得       ',
          grade: '', // 分数
          list: [
            {
              name: '1.“你先点点头，再把眼睛闭起来。” 『2/2』',
              grade: '', // 分数
              question: '2',
              pid: '1'
            },
            {
              name: '2.“这张图有没有手机？”',
              picture: '图卡一',
              pid: '2',
              grade: '' // 分数
            },
            {
              name: '3.“请指出可以吃和可以喝的东西。”『3/3』',
              picture: '图卡一',
              pid: '3',
              grade: '' // 分数
            },
            {
              name: '4.“请你指出手表、香蕉、杯子。”『3/3』',
              picture: '图卡一',
              pid: '4',
              grade: '' // 分数
            },
            {
              name: '5.“请指出在杯子上面的图片。”',
              picture: '图卡一',
              pid: '5',
              grade: '' // 分数
            },
            {
              name: '6.“请指出在苹果下面的图片。”',
              picture: '图卡一',
              pid: '6',
              grade: '' // 分数
            },
            {
              name: '7.“请指出手表上的分针。”',
              picture: '图卡一',
              pid: '7',
              grade: '' // 分数
            },
            {
              name: '8.“把所有日用品全部指出来。”『4/4』',
              picture: '图卡一',
              pid: '8',
              grade: '' // 分数
            },
            {
              name: '9.“如果这里有猴子，你就指它喜欢吃的香蕉；如果没有猴子，你就指苹果。”',
              picture: '图卡一',
              pid: '9',
              grade: '' // 分数
            },
            {
              name: '10.“哪些图片上有红色的东西？”『4/4』',
              picture: '图卡一',
              pid: '10',
              grade: '' // 分数
            },
            {
              name: '11.“哪些东西是长方形的？”『2/2』',
              picture: '图卡一',
              pid: '11',
              grade: '' // 分数
            },
            {
              name: '12.“请指出在手套和报纸中间的东西。”',
              pid: '12',
              picture: '图卡一',
              grade: '' // 分数
            },
            {
              name: '13.“把食物全部指出来。”『3/3』',
              pid: '13',
              picture: '图卡一',
              grade: '' // 分数
            },
            {
              name: '14.“吃了有营养的是哪些东西？”『3/3』',
              pid: '14',
              picture: '图卡一',
              grade: '' // 分数
            },
            {
              name: '15.“请指出清洁用品。”『3/3』',
              picture: '图卡二',
              pid: '15',
              grade: '' // 分数
            },
            {
              name: '16.“请指出人造的东西。”        『五项以上』',
              picture: '图卡二',
              pid: '16',
              grade: '' // 分数
            },
            {
              name: '17.“我先指雨伞，然后你再指草莓和气球。” 『2/2』',
              picture: '图卡二',
              pid: '17',
              grade: '' // 分数
            },
            {
              name: '18.“请指出可以在天上飞的东西。”『2/2』',
              picture: '图卡二',
              pid: '18',
              grade: '' // 分数
            },
            {
              name: '19.“老虎的头部朝向哪一张图片？”',
              picture: '图卡二',
              pid: '19',
              grade: '' // 分数
            },
            {
              name: '20.“请指出气球、草莓、和雨伞以外的四样东西。”『4/6』',
              picture: '图卡二',
              pid: '20',
              grade: '' // 分数
            },
            {
              name: '21.“哪一个图片代表储蓄罐？”',
              picture: '图卡三',
              pid: '21',
              grade: '' // 分数
            },
            {
              name: '22.“哪一个图片代表分工合作？”',
              picture: '图卡三',
              pid: '22',
              grade: '' // 分数
            },
            {
              name: '23.“哪一个图片表示爱护动物？”',
              picture: '图卡三',
              pid: '23',
              grade: '' // 分数
            },
            {
              name: '24.“哪一个图片表示有人在吵架？”',
              picture: '图卡三',
              pid: '24',
              grade: '' // 分数
            },
            {
              name: '25.“请你跟我重述数字‘8-3-2-9-6-4-7’”',
              pid: '25',
              grade: '' // 分数
            },
            {
              name: '26.“小华好快乐，小明好忧愁，谁的心情不好？”',
              pid: '26',
              grade: '' // 分数
            },
            {
              name: '27.“大雄很慷慨，小丸子很吝啬，谁比较小器？”',
              pid: '27',
              grade: '' // 分数
            },
            {
              name: '28.“哥哥有五百元存款，妹妹有一千元存款。谁比较有钱？”',
              pid: '28',
              grade: '' // 分数
            },
            {
              name: '29.下面哪一句话比较通顺？第一句：“他被窗户打破了。”；第二句：“他把窗户打破了。”',
              pid: '29',
              grade: '' // 分数
            },
            {
              name: '30.“火车马上就要开了。”这句话的意思是“火车已经开了。”，对不对？',
              pid: '30',
              grade: '' // 分数
            },
            {
              name: '31.“小明和妈妈要去动物园玩，他们想要坐火车去，爸爸就开车送他们去火车站。”请问：',
              pid: '31',
              special: '31', // 分数
              zooList: [
                {
                  name: '(1)“小明和谁要去玩？”',
                  pid: '(1)',
                  grade: '' // 分数
                },
                {
                  name: '(2)“他们要去哪里玩？”',
                  pid: '(2)',
                  grade: '' // 分数
                },
                {
                  name: '(3)“他们想要坐什么车去玩？”',
                  pid: '(3)',
                  grade: '' // 分数
                },
                {
                  name: '(4)“这个故事的‘他们’指的是谁？”『2/2』',
                  pid: '(4)',
                  grade: '' // 分数
                },
                {
                  name: '(5)“他们怎么去火车站？”',
                  pid: '(5)',
                  grade: '' // 分数
                }
              ]
              // grade: "" // 分数
            },
            {
              name: '32.“我家门前有一条小河，从前这条小河很清洁，但是，自从大家往河里乱丢垃圾之后，它就变成一条肮脏的小河了。邻居王伯伯是一位很慈爱的好人，他看见了这个样子以后，立刻请了许多工人把肮脏的垃圾清出去，使肮脏的河水又变成了干净的小河。”',
              pid: '32',
              special: '32', // 分数
              zooList: [
                {
                  name: '(1)“我家门前有什么？”『1/2』',
                  pid: '(1)',
                  grade: '' // 分数
                },
                {
                  name: '(2)“从前小河的水是什么样子？”『1/2』',
                  pid: '(2)',
                  grade: '' // 分数
                },
                {
                  name: '(3)“小河的水为什么会变脏？”『1/2』',
                  pid: '(3)',
                  grade: '' // 分数
                },
                {
                  name: '(4)“邻居王伯伯是什么样的人？”『2/3』',
                  pid: '(4)',
                  grade: '' // 分数
                },
                {
                  name: '(5)“王伯伯请谁把河水变干净了？”（工人）',
                  pid: '(5)',
                  grade: '' // 分数
                }
              ]
            }
          ],
          introduction:
            "<p>1、第2-20题不必回答，只要指对图片即可给分。</p><p>2、第10、11、13、14、16、18、20题如果受试只回答一个答案，可再进一步问<span style='color:red'>“还有呢？”</span>，最多不超过两次。</p><p>3、有『』者代表几分之几，无『』者，代表答案只有一个。例如：2/2表示需两个答案皆正确才算得分；3/4表示四个答案中，答对三个算正确。</p><p>4、计分：达到通过标准则计1分；答错或未达到通过标准则计0分。</p><p>5、第20-24题不必回答，只要指对图片即可给分。</p><p>6、第25题<span style='color:red'> ①指导语：“下面要念7个数字，你要注意听，我只念一遍，听完你要跟我说一遍，每一个数字念一秒钟。”</span>②次序与内容完全正确给一分</p><p>7、第26-30题 <span style='color:red'>①指导语：“下面我要念一些句子给你听，听完以后，你再说出答案。”</span>②完全正确给一分</p><p>8、第31-32题<span style='color:red'> ①指导语：“下面我要说两个小故事给你听，听完以后，我要问你几个问题，现在请你注意听。”</span>②每小题答对各给一分</p>"
        },
        {
          name: '分测验三  构音、声调、错误类型',
          showA: 3,
          checkList: [],
          checkListErr: [],
          toneErr: [],
          dysarthriaErr: [],
          errSound: '',
          sound: '',
          list: [
            {
              date: '图卡一',
              pid: '1',
              name: '1.“这是什么？”',
              articulation: 'p/ing',
              articulation2: 'g/uo',
              checkListErr: [],
              checkListErr2: []
            },
            {
              name: '2.“这是什么？”',
              pid: '2',
              articulation: 'n/iu',
              articulation2: 'n/ai',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '3',
              name: '3.“这是什么？”',
              articulation: 'x/i/ang',
              articulation2: 'j/i/ao',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '4',
              name: '4.“这是什么？”',
              articulation: 'b/ao',
              articulation2: 'zh/i',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '5',
              name: '5.“这是什么？”',
              articulation: 'sh/ou',
              articulation2: 't/ao',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '6',
              name: '6.“这是什么？”',
              articulation: 'er',
              articulation2: 'd/uo',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '7',
              name: '7.“这是什么？”',
              articulation: 'h/u',
              articulation2: 'd/ie',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '8',
              name: '8.“这是什么？”',
              articulation: 'yu',
              articulation2: 's/an',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '9',
              name: '9.“这是什么？”',
              articulation: 'c/ao',
              articulation2: 'm/ei',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '10',
              name: '10.“这是什么？”',
              articulation: 'j/i/q/i',
              articulation2: 'r/en',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '11',
              name: '11.“这是什么？”',
              articulation: 'l/ao',
              articulation2: 'h/u',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '12',
              name: '12.“这是什么？”',
              articulation: 'k/a',
              articulation2: 'ch/e',
              checkListErr: [],
              checkListErr2: []
            },
            {
              pid: '13',
              name: '13.“这是什么？”',
              articulation: 'f/ei',
              articulation2: 'z/ao',
              checkListErr: [],
              checkListErr2: []
            }
          ],
          introduction:
            "<p>1、施测者依题序指出图卡一与图卡二的图案，<span style='color:red'>指导语为：“这是什么？”</span></p><p>2、第1-13题最多念三次，构音可仿说。如受试看不懂13题（肥皂），施测者可告诉学生，这是féi zào ，让受试仿说，施测者在说时不让受试者看到嘴型或者说快一点，以免受试者刻意模仿发音方式。</p><p>3、计分方式：构音部分不计分，只记录正确音有几个，哪些是错误音，必要时可录音；声调部分不计分，只记录哪些声调有错误，可复选。</p> <p>4、错误类型：替代指正确的韵母和声母念成注音符号其它的发音；省略指受试者将正确的声母韵母省略；添加指受试者在正确的声母韵母中添加了其它的音；歪曲指受试者将正确的声母韵母念成注音符号中不存在的扭曲发音；整体含糊不清指受试者发音完全无法辨别。</p>"
        },
        {
          name: '分测验四：口语表达',
          showA: 4,
          nameAll: '口语表达 共57 分，评量结果得      ',
          grade: '', // 分数

          list: [
            {
              pid: '1',
              name: '1.“雨伞可以用来干什么？”『1/3』',
              grade: '', // 分数
              question: '2',
              picture: '图卡二'
            },
            {
              pid: '2',
              name: '2.“我们可以去哪些地方买菜？请至少说出两个地方。”『2项以上』',
              grade: '' // 分数
            },
            {
              pid: '3',
              name: '3.“如果不小心踩到别人的脚要说什么？”『2项以上』',
              grade: '' // 分数
            },
            {
              pid: '4',
              name: '4.“我用牙刷刷牙，你用什么扫地？”『2/3』',
              grade: '' // 分数
            },
            {
              pid: '5',
              name: '5.“过马路的时候要注意什么？”『3/4』',
              grade: '' // 分数
            },
            {
              pid: '6',
              name: '6.“便利商店卖些什么东西？”『3项以上』',
              grade: '' // 分数
            },
            {
              pid: '7',
              name: '7.“电话可以用来干什么？”『2项以上』',
              grade: '' // 分数
            },
            {
              pid: '8',
              name: '8.“垃圾车可以用来干什么？”『2项以上』',
              grade: '' // 分数
            },
            {
              pid: '9',
              name: '9.“病人和医院，学生和﹍﹍？”',
              grade: '' // 分数
            },
            {
              pid: '10',
              name: '10.“进步和退步，涨价和﹍﹍？”『1/2』',
              grade: '' // 分数
            },
            {
              pid: '11',
              name: '11.“破坏和建设；消极和﹍﹍？”',
              grade: '' // 分数
            },
            {
              pid: '12',
              name: '12.“与幸福相反的是什么？”『1/3』',
              grade: '' // 分数
            },
            {
              pid: '13',
              name: '13.“手套和手表有什么地方不一样？说出两者性质、功能不相同的地方。”『2项以上』',
              grade: '' // 分数
            },
            {
              pid: '14',
              name: '14.“苹果和香蕉有什么地方不一样？说出两者性质、功能不同的地方。”『2项以上』',
              grade: '' // 分数
            },
            {
              pid: '15',
              name: '15.“我们去医院看病，那去邮局可以做什么？”（3/5）',
              grade: '' // 分数
            },
            {
              pid: '16',
              name: '16.仿说句子：“我现在要说一些话，我说完后，你要跟我说一遍。”例：施测者：“我有一个球。”受试者：“我有一个球。”（请尽量说说看）',
              special: '16', //
              zooList: [
                {
                  pid: '(1)',
                  name: '(1)“我用眼睛看，你用耳朵听。”『5/7』',
                  grade: '' // 分数
                },
                {
                  pid: '(2)',
                  name: '(2)“老师叫我们要常常到操场运动。”『6/8』',
                  grade: '' // 分数
                },
                {
                  pid: '(3)',
                  name: '(3)“妹妹很想看电视节目，可是妈妈不让她看。”『6/9』',
                  grade: '' // 分数
                },
                {
                  pid: '(4)',
                  name: '(4)“张敏是一个精通多国语言的台湾奇女子，1978年12月携带着简单的行李，来到了南京。”『3/12』 ',
                  grade: '' // 分数
                },
                {
                  pid: '(5)',
                  name: '(5)“在协助孤儿的过程中，他深深体会到孩子那种无助、彷徨的心情，便产生爱屋及乌的博爱精神。”『3/14』',
                  grade: '' // 分数
                },
                {
                  pid: '(6)',
                  name: '(6)“父亲的话语不多，喜欢日出而作，日落而息的农耕生活，不管怎么搬家迁徙，总是想办法租借一块田地来种菜。”『4/18』',
                  grade: '' // 分数
                }
              ]
            },
            {
              pid: '17',
              name: '17.图卡四-1：“请你说说看，她在做什么？”',
              name2: '评量标准：',
              special: '17', //
              zooList: [
                {
                  pid: '(1)',
                  name: '(1)人物：能说出一项主词(如：她、我、小朋友、小妹妹、小孩子等) 『1/5』',
                  grade: '' // 分数
                },
                {
                  pid: '(2)',
                  name: '(2)地点：能说出(在房间、在床上) 『2/2』',
                  grade: '' // 分数
                },
                {
                  pid: '(3)',
                  name: '(3)时间：能说出(早上、太阳出来的时候、睡觉醒来的时候) 『2/3』',
                  grade: '' // 分数
                },
                {
                  pid: '(4)',
                  name: '(4)物品：能说出(窗户、床、拖鞋、棉被、枕头、窗帘、闹钟) 『4/7』',
                  grade: '' // 分数
                },
                {
                  pid: '(5)',
                  name: '(5)气候：能说出天气如何。(晴天、出太阳、太阳公公在微笑) 『2/3』',
                  grade: '' // 分数
                },
                {
                  pid: '(6)',
                  name: '(6)构句：至少能说出一句合乎题意的完整句子。',
                  grade: '' // 分数
                }
              ]
            },
            {
              pid: '18',
              name: '18.图卡四-2：“请你说说看，她在做什么？”',
              name2: '评量标准：',
              special: '18', //
              zooList: [
                {
                  pid: '(1)',
                  name: '(1)时间：能说出(起床后、早上、吃完东西) 『2/3』',
                  grade: '' // 分数
                },
                {
                  pid: '(2)',
                  name: '(2)地点：能说出(在浴室、在洗脸台前、在卫生间、在厕所里面) 『2/4』',
                  grade: '' // 分数
                },
                {
                  pid: '(3)',
                  name: '(3)动作：能说出(穿着睡衣、在刷牙、在洗脸) 『2/3』',
                  grade: '' // 分数
                },
                {
                  pid: '(4)',
                  name: '(4)物品：能说出(窗户、床、拖鞋、棉被、枕头、窗帘、闹钟) 『4/7』',
                  grade: '' // 分数
                },
                {
                  pid: '(5)',
                  name: '(5)构句：至少能说出一句合乎题意的完整句子。',
                  grade: '' // 分数
                }
              ]
            },
            {
              pid: '19',
              name: '19.图卡四-3：“请你说说看，她在做什么？”',
              name2: '评量标准：',
              special: '19', //
              zooList: [
                {
                  pid: '(1)',
                  name: '(1)时间：能说出(刷牙后、起床后) 『1/2』',
                  grade: '' // 分数
                },
                {
                  pid: '(2)',
                  name: '(2)地点：能说出(在房间、在床前) 『1/2』',
                  grade: '' // 分数
                },
                {
                  pid: '(3)',
                  name: '(3)物品：能说出(裙子、衣服、床、袜子、枕头等) 『4/5』',
                  grade: '' // 分数
                },
                {
                  pid: '(4)',
                  name: '(4)动作：能说出她正在做什么？（换/穿裙子、换/穿衣服、穿袜子) 『2/3』',
                  grade: '' // 分数
                },
                {
                  pid: '(5)',
                  name: '(5)构句：至少能说出一句合乎题意的完整句子。',
                  grade: '' // 分数
                }
              ]
            },
            {
              pid: '20',
              name: '20.图卡四-4：“请你说说看，她在做什么？”',
              name2: '评量标准：',
              special: '19', //
              zooList: [
                {
                  pid: '(1)',
                  name: '(1)时间：能说出(穿/换好衣服后、准备出门、准备上学) 『2/3』',
                  grade: '' // 分数
                },
                {
                  pid: '(2)',
                  name: '(2)地点：能说出(在门口、在门前) 『1/2』',
                  grade: '' // 分数
                },
                {
                  pid: '(3)',
                  name: '(3)物品：能说出(门、书包、垫子、鞋子、袜子、鞋柜) 『4/6』',
                  grade: '' // 分数
                },
                {
                  pid: '(4)',
                  name: '(4)动作：能说出(背书包、出门、上学、去学校) 『3/4』',
                  grade: '' // 分数
                },
                {
                  pid: '(5)',
                  name: '(5)构句：至少能说出一句合乎题意的完整句子。',
                  grade: '' // 分数
                }
              ]
            },
            {
              pid: '21',
              name: '21.“这个小朋友是小美，请你从图卡四-1到图卡四-4，从头到尾再说说看，她在做什么？”',
              name2: '评量标准：',
              special: '21', //
              zooList: [
                {
                  pid: '(1)',
                  name: '(1)故事是否切题？（与小美早上起床后做什么事有关者）',
                  grade: '' // 分数
                },
                {
                  pid: '(2)',
                  name: '(2)是否有逻辑性？（叙述有先后顺序的概念）',
                  grade: '' // 分数
                },
                {
                  pid: '(3)',
                  name: '(3)是否至少说出二句合乎题意的完整句子？ ',
                  grade: '' // 分数
                }
              ]
            },
            {
              pid: '22',
              name: '22.重述故事 ',
              nameList: [
                '（1）图卡五-1：“今天是小宝的生日。妈妈帮他准备一个巧克力鲜奶油蛋糕，姐姐和弟弟也一起祝福他生日快乐。”',
                '（2）图卡五-2：“小宝收到好多生日礼物，有尖尖的高帽子，还有装在大盒子和小盒子里的礼物，以及一台蓝色自行车。蓝色自行车的把手上还绑了一个好漂亮的红色气球。”',
                '（3）图卡五-3：“小宝好高兴喔！他马上跳上自行车，骑着自行车出去外面玩。红色气球在自行车前面飘呀飘。”',
                '（4）图卡五-4：“小宝骑呀！骑呀！突然间红色气球绳子松了，从自行车的把手上飘走了。小宝好难过喔。”'
              ],
              name2: '评量标准：',
              special: '22', //
              reword: '22', //
              zooList: [
                {
                  pid: '(1)',
                  name: '<p>(1)至少能说出二句合乎图卡五-1内容的完整句子。</p> <p>例①：今天是小宝的生日。</p><p>例②：大家在庆祝小宝的生日。</p>',
                  grade: '' // 分数
                },
                {
                  pid: '(2)',
                  name: '<p>(2)至少能说出二句合乎图卡五-2内容的完整句子。</p> <p>例①：小宝收到好多生日礼物。</p><p>例②：生日礼物有帽子、大盒/小盒礼物、蓝色自行车等。</p>',
                  grade: '' // 分数
                },
                {
                  pid: '(3)',
                  name: '<p>(3)至少能说出二句合乎图卡五-3内容的完整句子。</p> <p>例①：小宝很高兴马上跳上自行车。</p><p>例②：小宝骑自行车出去外面玩。</p> ',
                  grade: '' // 分数
                },
                {
                  pid: '(4)',
                  name: '<p>(4)至少能说出二句合乎图卡五-4内容的完整句子。</p> <p>例①：红色气球绳子松了。</p><p>例②：小红色气球飘走了。</p> ',
                  grade: '' // 分数
                },
                {
                  pid: '(5)',
                  name: '(5)不看图片，至少能重述图卡五1-4的其中二句内容。 ',
                  grade: '' // 分数
                }
              ]
            },
            {
              pid: '23',
              name: '23.自由说故事',
              name2: '评量标准：',
              nameList: [
                '“请你试试看，说一个你听过或你最喜欢的故事，或描述一件印象最深刻或最特别的事情。'
              ],
              reword: '23', //
              special: '23', //
              zooList: [
                {
                  pid: '(1)',
                  name: '(1)内容是否有主题？',
                  grade: '' // 分数
                },
                {
                  pid: '(2)',
                  name: '(2)内容是否有顺序性？',
                  grade: '' // 分数
                },
                {
                  pid: '(3)',
                  name: '(3)内容是否有逻辑性？',
                  grade: '' // 分数
                },
                {
                  pid: '(4)',
                  name: '(4)内容是否有头、有尾？',
                  grade: '' // 分数
                },
                {
                  pid: '(5)',
                  name: '(5)内容是否自编或自创？',
                  grade: '' // 分数
                },
                {
                  pid: '(6)',
                  name: '(6)能够说出故事或事件发生的意涵。',
                  grade: '' // 分数
                },
                {
                  pid: '(7)',
                  name: '(7)是否至少有一句是完整的句子？',
                  grade: '' // 分数
                }
              ]
            }
          ],
          introduction:
            "<p>1、第1-15题施测者按顺序念出题目，若受测者无反应，则施测者再念一遍；每题最多念三遍。</p><p>2、计分：达到通过标准则计1分；答错或未达到通过标准则计0分。</p><p>3、有『』者代表几分之几，无『』者，代表答案只有一个。例如：2/2表示需两个答案皆正确才算得分；3/4表示四个答案中，答对三个算正确。</p><p>4、第2-15题答案，如要求两项以上，受试只回答一项，可要求她/他多说一点。</p><p>5、第16题：仿说句子有六小题，每小题先念一遍后，请受试照样念一遍句子，若受试无反应，则施测者再念一遍指导语及题目，每小题最多念两遍；计分标准，如（5/7）即整句有七个词条，至少答对五个词条以上才得一分；如要求回答两项以上，可要求他/她多说一点。</p><p>6、第17题：①先经由施测者引导后，再请受试自己看图说故事；②施测者引导部分，将连环图呈现后，从上到下分别就图片1、2、3、4的顺序，问受试者：“每一张图片在说什么故事？”或“请你说说看，她在做什么？”可以鼓励受试多说一点，或问“这是谁？”“这是什么地方？”“她在做什么？”“这是什么时候？”“这里有些什么东西？”“她在做什么？”“她要去哪里？” ③四张图卡请受试分别讲完后，再请用小美的名字，从头到尾再说一遍；④计分：说出（）中的词，依评分标准计一分。如(在房间、在床前) 『1/2』，表示有两个答案，只要答对任何一个，即得一分。合乎题意是指句子的意义与图片内容一致；完整巨型是指至少有一个主语与动词的句子。</p><p>7、第18-21题：①先经由施测者引导后，再请受试自己看图说故事；②施测者引导部分，将连环图呈现后，从上到下分别就图片1、2、3、4的顺序，问受试者：<span style='color:red'>“每一张图片在说什么故事？”或“请你说说看，她在做什么？”</span>可以鼓励受试多说一点，或问<span style='color:red'>“这是谁？”“这是什么地方？”“她在做什么？”“这是什么时候？”“这里有些什么东西？”“她在做什么？”“她要去哪里？”</span>③四张图卡请受试分别讲完后，再请用小美的名字，从头到尾再说一遍；④计分：说出（）中的词，依评分标准计一分。如(在房间、在床前) 『1/2』，表示有两个答案，只要答对任何一个，即得一分。合乎题意是指句子的意义与图片内容一致；完整句型是指至少有一个主语与动词的句子。</p><p>8、第22题：①施测者从上到下，按照图片1、2、3、4得顺序，一边指着图片，一边对受试说一次故事内容，然后请受试照样说一遍。②故事内容根据评量项目里得描述进行。③<span style='color:red'>指导语：“现在我要依照这几个图说里面得故事给你听，请你注意听，等我说完就换你说给我听”</span>④故事说完后，如果受试不会重述，可再说明一下指导语及故事内容。受试者不肯说或停顿时，可以说，“小宝在干什么？”<span style='color:red'>“小宝最喜欢什么？”“然后呢？”“后来呢？”</span>⑤每小题按照评量标准给分，只要受试所说内容，符合每张图片得题意，而且至少有一句完整的句型，即可给一分。</p><p >8、第23题：请受试者说一个她/他最喜欢的故事或描述一件印象最深刻的事件，若受试说得太简单，可要求他/她多说一点。本题答题时间以不超过3分钟为原则。</p>"
        }
      ],
      addMany: false,
      showAfter: false,
      inputAfter: '',

      isShow: true,
      isShowBtn: true,
      page: 0, // 当前页
      // 选项
      radio: '',
      echo: '',
      //存放每一题的id和num
      questionInfos: [],
      // 题目的id
      ids: [],
      // 分数
      nums: [],
      studentId: sessionStorage.getItem('studentIdA'),
      showDialog: false,
      showGrade: false,
      gradeList: {
        answerDate: '',
        score: '0',
        studentAge: ''
      },
      totalTime: '',
      timeShow: '',
      times: '' //答题次数
    };
  },
  components: {
    oneTest,
    twoTest,
    threeTest,
    fourTest
  },
  mounted() {
    this.TopscrollTop();
  },
  created() {},

  methods: {
    TopscrollTop() {
      // document.querySelector(".grade").scrollTo(0, 0);
      window.scrollTo(0, 0);
    },
    // 总分
    saveCur(item, index) {
      this.questionInfos[index] = {
        ids: index,
        nums: this.radio,
        type: item.type,
        name: item.name
      };
    },

    // 跳到某题目
    toIndex(index) {
      this.page = index;
    },

    // 点击上一题
    toBack(item, index) {
      this.addMany = 0;
      // 1、保存当前
      this.saveCur(item, index);
      // 2 显示上一题
      this.toIndex(index - 1);

      this.isShowBtn = true;
    },
    oneTestSubmit() {
      this.addMany = this.questionList[this.page].list.every(
        (item) => item.voice && item.language && item.intonation
      );
      let list = JSON.parse(JSON.stringify(this.questionList[this.page].list));
      const filteredList = list.find(
        (item) => !item.voice || !item.language || !item.intonation
      );
      if (filteredList) {
        this.$message.warning('第' + filteredList.pid + '未选');
      }
    },
    twoTestSubmit() {
      this.addMany = this.questionList[this.page].list.every((item) => {
        return (
          item.grade || (item.zooList && item.zooList.every((obj) => obj.grade))
        );
      });
      let list = JSON.parse(JSON.stringify(this.questionList[this.page].list));
      const filteredList = list.find((item) => {
        if (item.zooList) {
          item.grade = item.zooList.every((obj) => obj.grade);
        }
        return !item.grade;
      });
      if (filteredList) {
        this.$message.warning('第' + filteredList.pid + '未选');
      }
    },
    threeTestSubmit() {
      this.addMany = this.questionList[this.page].list.every((item) => {
        return (
          item.grade || (item.zooList && item.zooList.every((obj) => obj.grade))
        );
      });
      let list = JSON.parse(JSON.stringify(this.questionList[this.page].list));
      const filteredList = list.find((item) => {
        if (item.zooList) {
          item.grade = item.zooList.every((obj) => obj.grade);
        }
        return !item.grade;
      });
      if (filteredList) {
        this.$message.warning('第' + filteredList.pid + '未选');
      }
    },
    // 下一题
    async toNext(item, index) {
      this.TopscrollTop();
      if (this.page === 0) {
        this.oneTestSubmit();
      } else if (this.page === 1) {
        this.twoTestSubmit();
      } else if (this.page === 2) {
        this.saveCur(item, index);
        this.toIndex(index + 1);
        if (this.page == this.questionList.length - 1) {
          this.$message.warning('最后一题');
          this.isShowBtn = false;
          return;
        } else {
          return (this.isShowBtn = true);
        }
      }
      if (this.addMany) {
        // 1、保存当前
        this.saveCur(item, index);
        // 2 显示下一题
        this.toIndex(index + 1);
      }
      //  else {
      //   return this.$message.error("请认真填写每一项");
      // }
    },
    // 点击提交
    async submit() {
      this.TopscrollTop();
      this.threeTestSubmit();
      if (this.addMany) {
        this.$message.success('答题完成');
      } else {
        return;
      }
      this.showAfter = true;
      let dateTimeAll = new Date();
      let dateTimeAllShow =
        dateTimeAll.getHours() + ':' + dateTimeAll.getMinutes();
      sessionStorage.setItem('dateTimeAllShowB', dateTimeAllShow);
      sessionStorage.setItem('questionList', JSON.stringify(this.questionList));
    },
    showAfterOk() {
      this.$router.push({ name: 'obstacleGrade' });
      this.showGrade = true;
    },
    conversionTime() {
      let dateTime2 = new Date().getTime();
      let dateTime1 = sessionStorage.getItem('dateTime');
      let add = dateTime2 - dateTime1;
      this.totalTime = Math.floor((add / (1000 * 60)) % 60);
      if (this.totalTime == '0') {
        this.totalTime = 1;
      }
      sessionStorage.setItem('totalTime', this.totalTime);
      let dateTimeAll = new Date();
      let dateTimeAllShow2 =
        dateTimeAll.getHours() + ':' + dateTimeAll.getMinutes();
      let dateTimeAllShow = sessionStorage.getItem('dateTimeAllShow');
      this.timeShow = dateTimeAllShow + ' - ' + dateTimeAllShow2;
      console.log(dateTimeAllShow);
      console.log(dateTimeAllShow2);
    },

    btnCancel() {
      this.showDialog = false;
    },
    showAfterCancel() {
      this.showAfter = false;
    },
    cutStudents() {
      this.$router.push({ name: 'student' });
      sessionStorage.removeItem('dateTime');
    },
    // 开始答题
    async beginTesting(item, index) {
      this.toNext(item, index);
      this.scaleAnswerNextTimes(this.studentId);
      let dateTime = new Date().getTime();
      let dateTimeAll = new Date();
      let dateTimeAllShow =
        dateTimeAll.getHours() + ':' + dateTimeAll.getMinutes();
      sessionStorage.setItem('dateTimeAllShow', dateTimeAllShow);
      sessionStorage.setItem('dateTime', dateTime);
    },
    // 次数
    async scaleAnswerNextTimes(id) {
      const { data } = await scaleAnswerNextTimes(id);
      console.log(data);
      this.times = data;
    }
  }
};
</script>

<style lang="scss" scoped>
#obstacle {
  margin: auto;
  // height: 100vh;
  background-color: #ffffff;
  padding: 100px;
  // background-color: #0a1531;
}
.btnSwitch {
  height: 50px;
  text-align: center;
  position: fixed;
  top: 90%;
  left: 50%;
  // margin-top: 70px;
  z-index: 99;
  transform: translate(-50%, -50%);
}
.topicBox {
  font-size: 20px;
  margin: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .topicBox_1 {
    display: flex;
  }
}
.audioMp3 {
  margin-left: 30px;
}
.checkboxS {
  display: flex;
  margin-left: 200px;
  .checkboxS_box {
    margin-left: 50px;
    .checkboxS_box_1 {
      display: flex;
      justify-content: center;
      .checkboxS_box_1_2 {
        margin-left: 20px;
      }
    }
  }
}
.lightHe {
  line-height: 1.5;
}
.inputAfterDialog {
  margin: 20px 0;
}
.dialog-footer {
  display: flex;
  margin-top: 50px;
  justify-content: center;
}
</style>
